import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MainRoutingModule } from './main-routing.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AgmCoreModule } from '@agm/core';
import { ChartsModule } from 'ng2-charts';
import { NgxMaskModule } from 'ngx-mask';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MainComponent } from './main.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { NgxStripeModule } from '@nomadreservations/ngx-stripe';
import { environment } from 'src/environments/environment';
import { AgmOverlays } from "agm-overlays";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RefreshBannerComponent } from '../generic-components/refresh-banner/refresh-banner.component';
import { ZoneRefreshBannerComponent } from '../generic-components/zone-refresh-banner/zone-refresh-banner.component';
import { NewNotificationComponent } from '../generic-components/new-notification/new-notification.component';
import { NewAlertNotificationComponent } from '../generic-components/new-alert-notification/new-alert-notification.component';
import { AuthInterceptorProvider } from '../services/token/token-interceptor.service';


@NgModule({
    declarations: [
        MainComponent,
        RefreshBannerComponent,
        ZoneRefreshBannerComponent,
        NewNotificationComponent,
        NewAlertNotificationComponent
    ],
    imports: [
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MainRoutingModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule, 
        ChartsModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        NgxStripeModule.forRoot(environment.stripe_pk),
        NgxMaskModule,
        AgmCoreModule,
        NgbModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        TranslateModule,
        AgmOverlays,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDWUBXmSgj5Af178JLrOc6kuysC_Evt7J8'
        }),
    ],
    providers: [
        AuthInterceptorProvider,
    ]
})
export class MainModule {}